/* contact-accordion.js — accordéon "Nous joindre" : un seul panneau ouvert à la fois.
   L'ouverture/fermeture de base est gérée nativement par <details>; ce script
   ferme simplement les autres panneaux quand l'utilisateur en ouvre un. */
(function () {
  function init() {
    var items = document.querySelectorAll('.joindre-accordion .joindre-item');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
